module.exports = __webpack_public_path__ + "static/media/aviva.2f5188fd.png";